import { render, staticRenderFns } from "./CreateOrderNominativ.vue?vue&type=template&id=67c0d545"
import script from "./CreateOrderNominativ.vue?vue&type=script&lang=js"
export * from "./CreateOrderNominativ.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderNominativ.vue?vue&type=style&index=0&id=67c0d545&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports